// Event tracking estruturado (F1-19) — base do MOAT de dados.
// Cada ação relevante do usuário vira um registro imutável no estado
// (persiste no localStorage e sobe pro Supabase junto com o resto do sync).
// O log alimenta score, predição (F3) e benchmark (F5) sem retrabalho.

import type { TrackedEvent } from '@app-types/domain';

export type TrackedEventType =
  | 'session.started'
  | 'session.completed'
  | 'session.abandoned'
  | 'goal.created'
  | 'goal.completed'
  | 'plan.generated'
  | 'focus.reported'
  | 'review.completed'
  | 'goal.progress'
  | 'score.snapshot';

export type { TrackedEvent };

/** teto do log local — eventos mais antigos são descartados (FIFO) */
export const EVENT_LOG_CAP = 5000;

let seq = 0;
export function makeEvent(type: TrackedEventType, payload: Record<string, unknown>): TrackedEvent {
  seq = (seq + 1) % 1000;
  return {
    id: `evt_${Date.now().toString(36)}_${seq.toString(36)}${Math.random().toString(36).slice(2, 6)}`,
    ts: new Date().toISOString(),
    type,
    payload,
  };
}

/** append imutável com cap — usado dentro dos updaters do store */
export function appendEvent(log: TrackedEvent[], event: TrackedEvent): TrackedEvent[] {
  const next = [...log, event];
  return next.length > EVENT_LOG_CAP ? next.slice(next.length - EVENT_LOG_CAP) : next;
}

/** contagem por tipo (debug / DEV panel / futuras métricas) */
export function countByType(log: TrackedEvent[]): Record<string, number> {
  const out: Record<string, number> = {};
  for (const e of log) out[e.type] = (out[e.type] || 0) + 1;
  return out;
}

/** eventos dentro de uma janela [fromIso, toIso) — insumo de score/predição */
export function eventsInRange(log: TrackedEvent[], fromIso: string, toIso: string): TrackedEvent[] {
  return log.filter((e) => e.ts >= fromIso && e.ts < toIso);
}
